/* eslint-disable no-console */
import { getCookie, setCookie } from '../cookies.js'

/**
 * 任意の値を指定したinput要素にセットする汎用ヘルパー関数（ページ全体から検索）
 * @param {string} selector - 値をセットするinput要素のセレクタ
 * @param {string} value - セットする値
 */
export const setInputValue = (selector, value) => {
  const targetInput = document.querySelector(selector)
  console.log('[surveyFormHelper] setInputValue:', {
    selector,
    found: !!targetInput,
    value,
  })
  if (targetInput && value) {
    targetInput.value = value
  }
}

/**
 * Cookie名を安全な文字列に変換
 * @param {string} key - 変換するキー
 * @returns {string} - 安全なキー
 */
const normalizeCookieKey = (key) => {
  if (!key || typeof key !== 'string') return ''
  return encodeURIComponent(key.replace(/\s+/g, '_'))
}

/**
 * フォームをCookieの有無で非表示にする
 * @param {Object} params - フォーム表示制御に使用するパラメータ
 * @param {string} params.cookieTag - Cookieのタグ
 * @param {string} params.formId - フォームのID
 * @param {string} params.afterSubmitId - フォーム送信後に表示する要素のID
 * @return {boolean} - フォームを非表示にしたかどうか
 */
export const hideFormIfCookie = ({ cookieTag, formId, afterSubmitId }) => {
  console.log('[surveyFormHelper] hideFormIfCookie:', {
    cookieTag,
    formId,
    afterSubmitId,
  })
  if (!cookieTag) return false
  const safeKey = normalizeCookieKey(cookieTag)
  if (!safeKey) return false
  const cookieValue = getCookie(safeKey)
  console.log('[surveyFormHelper] Cookie value:', cookieValue)
  if (cookieValue !== 'true') return false

  const formElement = document.getElementById(formId)
  const afterSubmitElement = document.getElementById(afterSubmitId)
  console.log('[surveyFormHelper] Elements:', {
    formFound: !!formElement,
    afterSubmitFound: !!afterSubmitElement,
  })
  if (!formElement || !afterSubmitElement) return false

  formElement.style.display = 'none'
  afterSubmitElement.style.display = 'block'
  console.log('[surveyFormHelper] Form hidden, after-submit shown')
  return true
}

/**
 * アンケート完了を示すCookieを設定する
 * @param {string} cookieTag - Cookieのタグ
 * @param {number} options.maxAge - Cookieの有効期限（秒、デフォルト: 3600秒 = 1時間）
 * @param {string} options.path - Cookieのパス
 * @param {string} options.sameSite - CookieのSameSite属性
 */
export const setSurveyCompletedCookie = (cookieTag, options = {}) => {
  console.log('[surveyFormHelper] setSurveyCompletedCookie:', {
    cookieTag,
    options,
  })
  if (!cookieTag) return
  const { maxAge = 3600, path = '/', sameSite = 'Lax' } = options
  const safeKey = normalizeCookieKey(cookieTag)
  if (!safeKey) return
  setCookie(safeKey, 'true', { maxAge, path, sameSite })
  console.log('[surveyFormHelper] Cookie set:', safeKey)
}

/**
 * アンケートフォームのリスナーを付与する
 * @param {string} formId - フォームのID
 * @param {Function} setCookie - Cookieを設定する関数
 * @return {boolean} - リスナーを付与したかどうか
 */
export const attachSurveyListeners = ({ formId, setCookie }) => {
  const container = document.getElementById(formId)
  console.log('[surveyFormHelper] attachSurveyListeners:', {
    formId,
    containerFound: !!container,
  })
  if (!container) return false

  const buttons = container.querySelectorAll(
    'button[type="submit"], input[type="submit"]'
  )
  console.log('[surveyFormHelper] Submit buttons found:', buttons.length)

  // iframe の確認
  const iframes = container.querySelectorAll('iframe')
  console.log('[surveyFormHelper] iframes found:', iframes.length)
  if (iframes.length > 0) {
    console.warn(
      '[surveyFormHelper] Form is inside iframe - cannot access from parent page'
    )
  }

  let attached = false
  buttons.forEach(function (button) {
    if (button.dataset.surveyListenerAttached === 'true') {
      return
    }
    button.addEventListener('click', function () {
      console.log('[surveyFormHelper] Submit button clicked')
      setCookie()
    })
    button.dataset.surveyListenerAttached = 'true'
    attached = true
  })
  console.log('[surveyFormHelper] Listeners attached:', attached)
  return attached
}

/**
 * フォームのDOM変化を監視し、リスナーを付与する
 * @param {string} targetId - 監視対象の要素ID
 * @param {Function} attachListeners - リスナーを付与する関数
 * @returns {MutationObserver} - 作成されたMutationObserver
 */
export const observeFormMutation = ({ targetId, attachListeners }) => {
  const targetNode = document.getElementById(targetId)
  console.log('[surveyFormHelper] observeFormMutation:', {
    targetId,
    nodeFound: !!targetNode,
  })
  if (!targetNode) return

  const observer = new MutationObserver((mutations, obs) => {
    console.log(
      '[surveyFormHelper] Mutation detected:',
      mutations.length,
      'mutations'
    )
    let attached = false
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        console.log(
          '[surveyFormHelper] Nodes added:',
          mutation.addedNodes.length
        )
        attached = attachListeners()
      }
    })
    if (attached) {
      console.log(
        '[surveyFormHelper] Listeners attached, disconnecting observer'
      )
      obs.disconnect()
    }
  })
  observer.observe(targetNode, {
    childList: true,
    subtree: true,
  })
  console.log('[surveyFormHelper] MutationObserver started')
  return observer
}
